export default "__VITE_ASSET__FzhZ$yPI__"